import { Field } from './Field';
import {GradientColorPicker} from '../../controls/gradient-color-picker/GradientColorPicker'
import '../../controls/gradient-color-picker/GradientColorPicker.css'

export class GradientColorPickerField extends Field {
  type: string ='gradient'
  picker: GradientColorPicker|null = null;
  public render(): HTMLElement {
    const container = this.createContainer();
    const input = document.createElement('div');
    input.id = this.name;
    let picker1 = new GradientColorPicker(input, this.value,(newValue)=>{
        this.value = newValue;        
        this.onChange(newValue);
    });
    this.picker = picker1;
    container.appendChild(input);
    return container;
  }
  public destroy(): void {
    this.picker?.destroy();
  }
}
